import { render, staticRenderFns } from "./CustomizableProduct.vue?vue&type=template&id=cecb8af6&scoped=true&"
import script from "./CustomizableProduct.vue?vue&type=script&lang=js&"
export * from "./CustomizableProduct.vue?vue&type=script&lang=js&"
import style0 from "./CustomizableProduct.vue?vue&type=style&index=0&id=cecb8af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecb8af6",
  null
  
)

export default component.exports